import {useEffect} from 'react';

import {useDispatch} from 'react-redux';

import {
    useGetAppCountryCountries,
    useGetAppCountryRegionsbycountry,
} from 'api/directory/country/country';
import {CountryType} from 'hostApplicationStoreType';
import {logWithSentry} from 'libs/sentry/sentry';
import {setCountries, setStates} from 'reducers/location/location';

// TODO: need to move in separate folders with tests
const COUNTRIES = {
    UNITED_STATES: 'US',
};
export const DEFAULT_COUNTRY = COUNTRIES.UNITED_STATES;

/**
 * hook for getting countries
 */
export const useGetCountries = () => {
    const dispatch = useDispatch();
    const {data: countries, error} = useGetAppCountryCountries({
        query: {
            refetchOnWindowFocus: false,
            select: data => data.map(({id, name}) => ({label: name, value: id})),
        },
    });

    useEffect(() => {
        if (countries) {
            dispatch(setCountries(countries));
        }
    }, [countries, dispatch]);

    return {countries, error};
};

/**
 * hook for getting country regions
 */
export const useGetRegions = (countryCode: string) => {
    const dispatch = useDispatch();
    const {data: regions, error} = useGetAppCountryRegionsbycountry(countryCode, {
        query: {
            enabled: Boolean(countryCode),
            refetchOnWindowFocus: false,
            select: data => ({
                [countryCode]:
                    data?.map?.(({code, id, name}) => ({
                        id: String(id),
                        label: name,
                        value: code,
                    })) || [],
            }),
        },
    });

    useEffect(() => {
        if (regions) {
            dispatch(setStates(regions));
        }
    }, [regions, dispatch]);
    return {error, regions};
};

/**
 * returns location data
 */
export const useGetLocation = (countryCode: string) => {
    const {countries, error: errorOnGetCountries} = useGetCountries();
    const {error: errorOnGetRegions, regions} = useGetRegions(countryCode);

    if (!errorOnGetCountries && !errorOnGetRegions) {
        return {countries, regions};
    }

    logWithSentry((errorOnGetCountries || errorOnGetRegions) as Error);

    return {
        countries: [] as CountryType[],
        regions: null,
    };
};
